export default __webpack_public_path__ + "static/media/left scissors.80043d44.png";